import { ThemeEvents } from '@theme/events';

/**
 * Updates servings label on variant change by swapping in the updated markup
 * from the section-rendered HTML returned by the variant picker fetch.
 */
class VariantServings extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');
    target?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /**
   * @param {CustomEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail?.data?.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.detail?.data?.productId &&
      this.dataset.productId &&
      event.detail.data.productId !== this.dataset.productId
    ) {
      return;
    }

    const source = event.detail?.data?.html;
    if (!source) return;

    const newEl = source.querySelector(`variant-servings[data-block-id="${CSS.escape(this.dataset.blockId || '')}"]`);
    if (!newEl) return;

    this.replaceWith(newEl);
  };
}

if (!customElements.get('variant-servings')) {
  customElements.define('variant-servings', VariantServings);
}

